<template>
  <div id="leftBarIdentify">
    <v-card
      class="leftBarTabsItem leftBarTabsItemIdentify"
      v-if="core.displayXY(coordinate)"
    >
      <v-card-subtitle class="leftBarTabsItemIdentifyHeader">{{
        $t("common.coordinates")
      }}</v-card-subtitle>
      <v-card
        class="leftBarTabsItem"
        @click="leftBar.zoomToIdentifyMainMarker()"
      >
        <v-list-item class="leftBarTabsItemItem">
          <v-img
            v-if="core.leftBarWidthSize != 'xs'"
            class="leftBarTabsItemItemIcon"
            :src="'lib/images/marker-icon-green-search.png'"
          ></v-img>
          <v-list-item-content>
            <v-list-item-title>
              <v-img
                v-if="core.leftBarWidthSize == 'xs'"
                class="leftBarTabsItemItemIcon"
                :src="'lib/images/marker-icon-green-search.png'"
              ></v-img>
            </v-list-item-title>

            <v-list-item-subtitle class="listItemSubtitle"
              >{{
                $t("common.latitude") + ", " + $t("common.longitude")
              }}:</v-list-item-subtitle
            >
            <v-list-item-title>
              <div>
                {{ core.displayXY(coordinate).lat }}
              </div>
              <div>
                {{ core.displayXY(coordinate).lng }}
              </div>
            </v-list-item-title>

            <v-list-item-subtitle class="listItemSubtitle">
              {{
                $t("common.hk80y") + ", " + $t("common.hk80x")
              }}:</v-list-item-subtitle
            >
            <v-list-item-title>
              <div>
                {{ core.displayHK80(coordinate)[1] }}
              </div>
              <div>
                {{ core.displayHK80(coordinate)[0] }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
          <LeftBarSubButtons
            v-if="core.leftBarWidthSize != 'xs'"
            :index="0"
            :core="core"
            :tour="tour"
            :data="{
              latLng: coordinate,
              resultType: 'identify',
            }"
            :showAdvanced="false"
          ></LeftBarSubButtons>
        </v-list-item>

        <LeftBarSubButtons
          v-if="core.leftBarWidthSize == 'xs'"
          :index="0"
          :core="core"
          :tour="tour"
          :data="{
            latLng: coordinate,
            resultType: 'identify',
          }"
          :showAdvanced="false"
        ></LeftBarSubButtons>
      </v-card>
    </v-card>

    <template
      v-if="
        leftBar.identifyResult &&
        Array.isArray(leftBar.identifyResult) &&
        leftBar.identifyResult.length > 0
      "
    >
      <template v-for="(ir, i) in leftBar.identifyResult">
        <!--lot-->
        <template v-if="ir.type === GLOBAL.GEOINFOMAP.ITEM_TYPE.LOT_TYPE_LOT">
          <v-card
            :key="ir.type + '_' + i"
            class="leftBarTabsItem leftBarTabsItemIdentify"
          >
            <v-card-subtitle class="leftBarTabsItemIdentifyHeader">{{
              core.locate == GLOBAL.LANG.EN ? ir.eheader : ir.cheader
            }}</v-card-subtitle>
            <v-card
              :key="ai + '_' + j"
              v-for="(ai, j) in ir.addressInfo"
              class="leftBarTabsItem"
              @click="
                core.enableIden
                  ? core.leftBar.zoomToIdentifyMainMarker()
                  : !core.enableIdentifyResultLayer
                  ? leftBar.zoomToIdentifyMainMarker()
                  : leftBar.findSelectedIdentify(ai.LOTID)
                  ? leftBar.clearSelectedIdentify(ai.LOTID)
                  : ai.LTYPE == GLOBAL.GEOINFOMAP.ITEM_TYPE.LOT_TYPE_GLA
                  ? leftBar.queryGla(ai)
                  : leftBar.queryLot(ai)
              "
            >
              <v-list-item
                :class="
                  core.enableIdentifyResultLayer &&
                  leftBar.findSelectedIdentify(ai.LOTID)
                    ? 'leftBarTabsItemItem selected'
                    : 'leftBarTabsItemItem'
                "
              >
                <template v-if="core.leftBarWidthSize != 'xs'">
                  <v-icon
                    v-if="core.enableIdentifyResultLayer"
                    large
                    class="leftBarTabsItemItemIcon leftBarTabsItemIdentifyItemIcon"
                    >crop_free</v-icon
                  >
                  <v-img
                    v-else
                    class="leftBarTabsItemItemIcon"
                    :src="'lib/images/marker-icon-green-search.png'"
                  ></v-img>
                </template>

                <v-list-item-content>
                  <v-list-item-title v-if="core.leftBarWidthSize == 'xs'">
                    <v-icon
                      v-if="core.enableIdentifyResultLayer"
                      large
                      class="leftBarTabsItemItemIcon leftBarTabsItemIdentifyItemIcon"
                      >crop_free</v-icon
                    >
                    <v-img
                      v-else
                      class="leftBarTabsItemItemIcon"
                      :src="'lib/images/marker-icon-green-search.png'"
                    ></v-img>
                  </v-list-item-title>

                  <!--LOT: GLA-->
                  <template
                    v-if="ai.LTYPE == GLOBAL.GEOINFOMAP.ITEM_TYPE.LOT_TYPE_GLA"
                  >
                    <template v-if="ai.LOT_FULLNAME">
                      <v-list-item-subtitle class="listItemSubtitle"
                        >{{ $t("common.lotName") }}:</v-list-item-subtitle
                      >
                      <v-list-item-title v-if="ai.LOT_FULLNAME">{{
                        leftBar.changeHTMLString(ai.LOT_FULLNAME)
                      }}</v-list-item-title>
                    </template>
                  </template>
                  <!--LOT: LOT-->
                  <template
                    v-else-if="
                      ai.LTYPE == GLOBAL.GEOINFOMAP.ITEM_TYPE.LOT_TYPE_LOT
                    "
                  >
                    <v-list-item-title v-if="ai.LOT_FULLNAME"
                      ><span style="font-weight: bold">{{
                        leftBar.changeHTMLString(ai.LOT_FULLNAME)
                      }}</span></v-list-item-title
                    >

                    <template v-if="ai.LOTNAME">
                      <v-list-item-subtitle class="listItemSubtitle"
                        >{{ $t("common.lotName") }}:</v-list-item-subtitle
                      >
                      <v-list-item-title v-if="ai.LOTNAME">{{
                        leftBar.changeHTMLString(ai.LOTNAME)
                      }}</v-list-item-title>
                    </template>
                    <template v-if="ai.PRN">
                      <v-list-item-subtitle class="listItemSubtitle"
                        >{{ $t("common.prn") }}:</v-list-item-subtitle
                      >
                      <v-list-item-title>{{
                        leftBar.changeHTMLString(ai.PRN)
                      }}</v-list-item-title>
                    </template></template
                  >
                </v-list-item-content>

                <LeftBarSubButtons
                  v-if="core.leftBarWidthSize != 'xs'"
                  :core="core"
                  :tour="tour"
                  :data="{
                    latLng: coordinate,
                    name_en: leftBar.changeHTMLString(ai.LOT_FULLNAME),
                    name_zh: leftBar.changeHTMLString(ai.LOT_FULLNAME),
                    resultType: 'identify',
                  }"
                  :showAdvanced="true"
                ></LeftBarSubButtons>
              </v-list-item>
              <LeftBarSubButtons
                v-if="core.leftBarWidthSize == 'xs'"
                :core="core"
                :tour="tour"
                :data="{
                  latLng: coordinate,
                  name_en: leftBar.changeHTMLString(ai.LOT_FULLNAME),
                  name_zh: leftBar.changeHTMLString(ai.LOT_FULLNAME),
                  resultType: 'identify',
                }"
                :showAdvanced="true"
              ></LeftBarSubButtons>
            </v-card>
          </v-card>
        </template>
        <!--address-->
        <template v-if="ir.type === GLOBAL.GEOINFOMAP.ITEM_TYPE.ADDRESS_TYPE">
          <v-card
            :key="ir.type + '_' + i"
            class="leftBarTabsItem leftBarTabsItemIdentify"
          >
            <v-card-subtitle class="leftBarTabsItemIdentifyHeader">{{
              core.locate == GLOBAL.LANG.EN ? ir.eheader : ir.cheader
            }}</v-card-subtitle>
            <v-card
              :key="ai + '_' + j"
              v-for="(ai, j) in ir.addressInfo"
              class="leftBarTabsItem"
              @click="
                !core.enableIdentifyResultLayer
                  ? leftBar.zoomToIdentifyMainMarker()
                  : leftBar.findSelectedIdentify(ai.uniqueId)
                  ? leftBar.clearSelectedIdentify(ai.uniqueId)
                  : ai.addressType &&
                    ai.addressType ==
                      GLOBAL.GEOINFOMAP.ITEM_TYPE.ADDRESS_TYPE_ST
                  ? leftBar.queryStreet(ai)
                  : leftBar.zoomToIdentifyMainMarker()
              "
            >
              <v-list-item
                :class="
                  core.enableIdentifyResultLayer &&
                  leftBar.findSelectedIdentify(ai.uniqueId)
                    ? 'leftBarTabsItemItem selected'
                    : 'leftBarTabsItemItem'
                "
              >
                <template
                  v-if="
                    ai.addressType &&
                    ai.addressType ==
                      GLOBAL.GEOINFOMAP.ITEM_TYPE.ADDRESS_TYPE_ST
                  "
                >
                  <template v-if="core.leftBarWidthSize != 'xs'">
                    <v-icon
                      v-if="core.enableIdentifyResultLayer"
                      large
                      class="leftBarTabsItemItemIcon leftBarTabsItemIdentifyItemIcon"
                      >mdi-road-variant</v-icon
                    >
                    <v-img
                      v-else
                      class="leftBarTabsItemItemIcon"
                      :src="'lib/images/marker-icon-green-search.png'"
                    ></v-img>
                  </template>

                  <v-list-item-content>
                    <v-list-item-title v-if="core.leftBarWidthSize == 'xs'">
                      <v-icon
                        v-if="core.enableIdentifyResultLayer"
                        large
                        class="leftBarTabsItemItemIcon leftBarTabsItemIdentifyItemIcon"
                        >mdi-road-variant</v-icon
                      >
                      <v-img
                        class="leftBarTabsItemItemIcon"
                        :src="'lib/images/marker-icon-green-search.png'"
                      ></v-img>
                    </v-list-item-title>
                    <v-list-item-title v-if="ai.ename">{{
                      leftBar.changeHTMLString(ai.ename)
                    }}</v-list-item-title>
                    <v-list-item-title v-if="ai.cname">{{
                      leftBar.changeHTMLString(ai.cname)
                    }}</v-list-item-title>

                    <v-list-item-title v-if="ai.eaddress && ai.caddress"
                      >&nbsp;&nbsp;&nbsp;</v-list-item-title
                    >
                    <v-list-item-title v-if="ai.eaddress && ai.caddress"
                      >&nbsp;&nbsp;&nbsp;</v-list-item-title
                    >

                    <v-list-item-subtitle v-if="ai.eaddress">{{
                      leftBar.changeHTMLString(ai.eaddress)
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="ai.caddress">{{
                      leftBar.changeHTMLString(ai.caddress)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <LeftBarSubButtons
                    v-if="core.leftBarWidthSize != 'xs'"
                    :core="core"
                    :tour="tour"
                    :data="{
                      latLng: coordinate,
                      name_en: leftBar.changeHTMLString(ai.ename),
                      name_zh: leftBar.changeHTMLString(ai.cname),
                      address_en: leftBar.changeHTMLString(ai.eaddress),
                      address_zh: leftBar.changeHTMLString(ai.caddress),
                      resultType: 'identify',
                    }"
                    :showAdvanced="true"
                  ></LeftBarSubButtons>
                </template>
                <template v-else>
                  <v-img
                    v-if="core.leftBarWidthSize != 'xs'"
                    class="leftBarTabsItemItemIcon"
                    :src="'lib/images/marker-icon-green-search.png'"
                  ></v-img>

                  <v-list-item-content>
                    <v-list-item-title v-if="core.leftBarWidthSize == 'xs'">
                      <v-img
                        class="leftBarTabsItemItemIcon"
                        :src="'lib/images/marker-icon-green-search.png'"
                      ></v-img>
                    </v-list-item-title>
                    <v-list-item-title v-if="ai.ename">{{
                      leftBar.changeHTMLString(ai.ename)
                    }}</v-list-item-title>
                    <v-list-item-title v-if="ai.cname">{{
                      leftBar.changeHTMLString(ai.cname)
                    }}</v-list-item-title>

                    <v-list-item-title v-if="ai.eaddress && ai.caddress"
                      >&nbsp;&nbsp;&nbsp;</v-list-item-title
                    >
                    <v-list-item-title v-if="ai.eaddress && ai.caddress"
                      >&nbsp;&nbsp;&nbsp;</v-list-item-title
                    >

                    <v-list-item-subtitle v-if="ai.eaddress">{{
                      leftBar.changeHTMLString(ai.eaddress)
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="ai.caddress">{{
                      leftBar.changeHTMLString(ai.caddress)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <LeftBarSubButtons
                    v-if="core.leftBarWidthSize != 'xs'"
                    :core="core"
                    :tour="tour"
                    :data="{
                      latLng: coordinate,
                      name_en: leftBar.changeHTMLString(ai.ename),
                      name_zh: leftBar.changeHTMLString(ai.cname),
                      address_en: leftBar.changeHTMLString(ai.eaddress),
                      address_zh: leftBar.changeHTMLString(ai.caddress),
                      resultType: 'identify',
                    }"
                    :showAdvanced="true"
                  ></LeftBarSubButtons>
                </template>
              </v-list-item>
              <LeftBarSubButtons
                v-if="core.leftBarWidthSize == 'xs'"
                :core="core"
                :tour="tour"
                :data="{
                  latLng: coordinate,
                  name_en: leftBar.changeHTMLString(ai.ename),
                  name_zh: leftBar.changeHTMLString(ai.cname),
                  address_en: leftBar.changeHTMLString(ai.eaddress),
                  address_zh: leftBar.changeHTMLString(ai.caddress),
                  resultType: 'identify',
                }"
                :showAdvanced="true"
              ></LeftBarSubButtons>
            </v-card> </v-card
        ></template>
        <!--faci-->
        <template v-if="ir.type === GLOBAL.GEOINFOMAP.ITEM_TYPE.FACI_TYPE">
          <v-card
            :key="ir.type + '_' + i"
            class="leftBarTabsItem leftBarTabsItemIdentify"
          >
            <v-card-subtitle class="leftBarTabsItemIdentifyHeader">{{
              core.locate == GLOBAL.LANG.EN ? ir.eheader : ir.cheader
            }}</v-card-subtitle>
            <v-card class="leftBarTabsItem">
              <v-list-item
                :key="ai + '_' + j"
                v-for="(ai, j) in ir.addressInfo"
                class="leftBarTabsItemItem"
                @click="leftBar.zoomToIdentifyMainMarker()"
              >
                <v-img
                  v-if="core.leftBarWidthSize != 'xs'"
                  class="leftBarTabsItemItemIcon"
                  :src="'lib/images/marker-icon-green-search.png'"
                ></v-img>
                <v-list-item-content
                  ><v-list-item-title v-if="core.leftBarWidthSize == 'xs'">
                    <v-img
                      class="leftBarTabsItemItemIcon"
                      :src="'lib/images/marker-icon-green-search.png'"
                    ></v-img>
                  </v-list-item-title>
                  <v-list-item-title v-if="ai.ename">{{
                    leftBar.changeHTMLString(ai.ename)
                  }}</v-list-item-title>
                  <v-list-item-title v-if="ai.cname">{{
                    leftBar.changeHTMLString(ai.cname)
                  }}</v-list-item-title>

                  <v-list-item-title v-if="ai.eaddress && ai.caddress"
                    >&nbsp;&nbsp;&nbsp;</v-list-item-title
                  >
                  <v-list-item-title v-if="ai.eaddress && ai.caddress"
                    >&nbsp;&nbsp;&nbsp;</v-list-item-title
                  >

                  <v-list-item-subtitle v-if="ai.eaddress">{{
                    leftBar.changeHTMLString(ai.eaddress)
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="ai.caddress">{{
                    leftBar.changeHTMLString(ai.caddress)
                  }}</v-list-item-subtitle>
                </v-list-item-content>

                <LeftBarSubButtons
                  v-if="core.leftBarWidthSize != 'xs'"
                  :core="core"
                  :tour="tour"
                  :data="{
                    latLng: coordinate,
                    name_en: leftBar.changeHTMLString(ai.ename),
                    name_zh: leftBar.changeHTMLString(ai.cname),
                    address_en: leftBar.changeHTMLString(ai.eaddress),
                    address_zh: leftBar.changeHTMLString(ai.caddress),
                    resultType: 'identify',
                  }"
                  :showAdvanced="true"
                ></LeftBarSubButtons>
              </v-list-item>
              <LeftBarSubButtons
                v-if="core.leftBarWidthSize == 'xs'"
                :core="core"
                :tour="tour"
                :data="{
                  latLng: coordinate,
                  name_en: leftBar.changeHTMLString(ai.ename),
                  name_zh: leftBar.changeHTMLString(ai.cname),
                  address_en: leftBar.changeHTMLString(ai.eaddress),
                  address_zh: leftBar.changeHTMLString(ai.caddress),
                  resultType: 'identify',
                }"
                :showAdvanced="true"
              ></LeftBarSubButtons>
            </v-card> </v-card
        ></template>
      </template>
    </template>
  </div>
</template>

<script>
import * as GLOBAL from "./Global";
import LeftBarSubButtons from "./LeftBarSubButtons";

export default {
  components: { LeftBarSubButtons },

  props: ["core", "tour", "leftBar"],

  computed: {
    coordinate() {
      this.leftBar.identifyXY;
      // console.log( this.core.identifyMainDrawnItems.getLayers()[0]
      if (this.core.identifyMainDrawnItems.getLayers().length == 1) {
        return this.core.identifyMainDrawnItems.getLayers()[0].getLatLng();
      }
      return null;
    },
  },

  data() {
    return {
      GLOBAL: GLOBAL,
    };
  },

  methods: {
    //20210106 -tedngok -hidden for matching field form
    // addIdentifyResult({ name_zh, name_en, address_zh, address_en }) {
    //   // console.log(leaflet_id, name_zh, name_en, address_zh, address_en);

    //   let leftBar = this.leftBar;

    //   // all changed to only add point
    //   // if (!leaflet_id) {
    //   //   leaflet_id = this.core.identifyMainDrawnItems.getLayers()[0]
    //   //     ._leaflet_id;
    //   // }

    //   //get current xy point only
    //   let leaflet_id = this.core.identifyMainDrawnItems.getLayers()[0]
    //     ._leaflet_id;

    //   if (this.core.existingSpecialFieldTypes()) {
    //     leftBar.addItemByIdentifyResult({
    //       leaflet_id,
    //       name_zh,
    //       name_en,
    //       address_zh,
    //       address_en,
    //     });
    //   } else {
    //     if (this.core.enableShowInputSpecialTypeDialog) {
    //       this.core.clearConfirmDialog();
    //       this.core.confirmDialogOK = () => {
    //         leftBar.addItemByIdentifyResult({
    //           leaflet_id,
    //           name_zh,
    //           name_en,
    //           address_zh,
    //           address_en,
    //         });
    //       };
    //       this.core.confirmDialogMessage = this.$t(
    //         "common.confirmInputMessage"
    //       );
    //       this.core.confirmDialog = true;
    //       this.core.goToLastTablePage();
    //     } else {
    //       leftBar.addItemByIdentifyResult({
    //         leaflet_id,
    //         name_zh,
    //         name_en,
    //         address_zh,
    //         address_en,
    //       });
    //     }
    //   }

    //   this.core.goToLastTablePage();
    // },

    init() {
      let me = this;
      me.leftBar.enableLeftBarTabsClearSearchResults(false);
      this.leftBar.chgToolBarButtons({
        toolbarTitle: "",
        toolbarExtent: () => {
          me.$GA.identify_click_extent();
          me.leftBar.extentIdentifyResultDrawnItemBounds();
        },
        toolbarTrash: () => {
          me.$GA.identify_click_trash();
          me.leftBar.identifyXY = null;
          me.leftBar.identifyResult = null;

          me.leftBar.openDynamicTab({ dynamicTab: null, showLeftBar: false });

          me.leftBar.enableLeftBarTabsClearSearchResults(true);
        },
      });
    },
  },
};
</script>